<template>
<div class="chapter">
<div class="inner_page">
<div class="pagebreak">
</div>
<h1 class="tocchaptitle"><a id="contents"></a>CONTENTS</h1>
<p class="toc"><a href="#/06_introduction#intro">INTRODUCTION</a></p>
<p class="toc1"><a href="#/07_chapter01#c1"><b>1 WHAT JUST HAPPENED?</b></a></p>
<p class="toc"><a href="#/07_chapter01#c11">LIFE BEYOND THE DIAGNOSIS</a></p>
<p class="toc1"><span href="#/08_chapter02#c2" title="Link target outside of Sample"><b>2 MANIA, DEPRESSION, PSYCHOSIS, OH MY!</b></span></p>
<p class="toc"><span href="#/08_chapter02#c21" title="Link target outside of Sample">A WHIRLWIND TOUR THROUGH THE EPISODES OF BIPOLAR DISORDER</span></p>
<p class="toc1"><span href="#/09_chapter03#c3" title="Link target outside of Sample"><b>3 YOU'VE GOT DRUGS</b></span></p>
<p class="toc"><span href="#/09_chapter03#c31" title="Link target outside of Sample">WRAPPING YOUR HEAD AROUND MEDS</span></p>
<p class="toc1"><span href="#/10_chapter04#c4" title="Link target outside of Sample"><b>4 SHRINKS</b></span></p>
<p class="toc"><span href="#/10_chapter04#c41" title="Link target outside of Sample">WHAT THEY'RE FOR AND HOW THEY CAN HELP</span></p>
<p class="toc1"><span href="#/11_chapter05#c5" title="Link target outside of Sample"><b>5 THIS IS YOUR MANAGER SPEAKING</b></span></p>
<p class="toc"><span href="#/11_chapter05#c51" title="Link target outside of Sample">TAMING EPISODES WITH FOOD, SLEEP, AND EXERCISE</span></p>
<p class="toc1"><span href="#/12_chapter06#c6" title="Link target outside of Sample"><b>6 GRACE UNDER FIRE</b></span></p>
<p class="toc"><span href="#/12_chapter06#c61" title="Link target outside of Sample">KEEPING A COOL HEAD IN CRAPPY SITUATIONS</span></p>
<p class="toc1"><span href="#/13_chapter07#c7" title="Link target outside of Sample"><b>7 HERE BE DOWNERS</b></span></p>
<p class="toc"><span href="#/13_chapter07#c71" title="Link target outside of Sample">DRUGS, BOOZE, AND SUICIDE</span></p>
<p class="toc1"><span href="#/14_chapter08#c8" title="Link target outside of Sample"><b>8 THE GAME OF LIFE</b></span></p>
<p class="toc"><span href="#/14_chapter08#c81" title="Link target outside of Sample">BIPOLAR IN COLLEGE AND AT WORK</span></p>
<p class="toc1"><span href="#/15_chapter09#c9" title="Link target outside of Sample"><b>9 VOICES NOT IN YOUR HEAD</b></span></p>
<p class="toc"><span href="#/15_chapter09#c91" title="Link target outside of Sample">DEALING WITH FRIENDS AND FAMILY</span></p>
<p class="toc1"><span href="#/16_chapter10#c10" title="Link target outside of Sample"><b>10 HIPPIE SHIT THAT ACTUALLY WORKS</b></span></p>
<p class="toc"><span href="#/16_chapter10#c101" title="Link target outside of Sample">HERBS, WILDERNESS TIME, AND OTHER WAYS TO HELP YOURSELF KEEP YOUR SHIT TOGETHER</span></p>
<p class="toc1"><span href="#/17_chapter11#c11" title="Link target outside of Sample"><b>11 HELL IS FINDING GOOD INSURANCE</b></span></p>
<p class="toc"><span href="#/17_chapter11#c111" title="Link target outside of Sample">HOW TO GET YOUR ASS COVERED IN TROUBLED TIMES</span></p>
<p class="toc"><span href="#/18_conclusion#con" title="Link target outside of Sample">CONCLUSION</span></p>
<p class="toc"><span href="#/19_resources#res" title="Link target outside of Sample">RESOURCES</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_contents.vue?60a3e68c